import React from 'react';
import styled from 'styled-components';
import sizes from '../tools/theme/theme-items/sizes';
import { Button } from '../Action';
import { useShow } from './utils';
import { useMediaSize } from '../tools/utils';
const StyledSnackbarContainer = styled.div `
  ${({ theme: { colors }, columnSize, show, isMdDown }) => `
    background-color: ${colors['gray-800']};
    color: ${colors.white};
    width: ${isMdDown ? sizes[11] : sizes[columnSize]};
    opacity: ${show ? '1' : '0'};
  `}

  display: flex;
  border-radius: 4px;
  align-items: center;
  position: fixed;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;

  box-shadow: 0px 5px 8px -4px rgba(0, 0, 0, 0.16),
    0px 2px 4px -2px rgba(0, 0, 0, 0.16);
  padding: 14px 16px 14px 16px;

  transition: opacity 0.25s ease-in-out;

  @media print {
    display: none !important;
  }
`;
const StyledSnackbarContent = styled.span `
  ${({ theme: { font, fonts } }) => `
    font-size: ${font.body.sm.size};
    font-family: ${fonts.regular};
    line-height: ${font.body.sm.lineHeight};
  `}

  flex: 1;
  :focus {
    outline: none;
  }
`;
const StyledSnackbarButton = styled(Button) `
  ${({ theme: { colors } }) => `
    color: ${colors['blue-500']};
  `}
  margin-left: 30px;
  white-space: normal;
`;
export const Snackbar = React.forwardRef(({ text, columnSize = 6, snackbarButtonOnClick, snackbarButtonText, buttonOnBlur, buttonOnFocus, }, ref) => {
    const { show } = useShow();
    const isMdDown = useMediaSize('MdDown');
    return (React.createElement(StyledSnackbarContainer, { show: show, columnSize: columnSize, isMdDown: isMdDown, "data-testid": "mui-snackbar" },
        React.createElement(StyledSnackbarContent, { ref: ref, tabIndex: -1, "data-testid": "mui-snackbar-content" }, text),
        snackbarButtonText && (React.createElement(StyledSnackbarButton, { variant: "link", text: snackbarButtonText, onClick: snackbarButtonOnClick, onFocus: buttonOnFocus, onBlur: buttonOnBlur, "data-testid": "mui-snackbar-button" }))));
});
//# sourceMappingURL=Snackbar.js.map